import { Button, Form, Col, Row } from 'react-bootstrap'

function Filter({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    badgeChoices,
    chosenBadge,
    setChosenBadge,
    handleSearch,
}) {
    return (
        <>
            <Form>
                <Form.Row>
                    <Form.Group as={Col} controlId="formGridPassword">
                        <Form.Label>Цол</Form.Label>
                        <Form.Control
                            as="select"
                            value={chosenBadge}
                            className="form-control"
                            onChange={(e) => {
                                setChosenBadge(e.target.value)
                            }}
                        >
                            <option key={''} value={''}>
                                Бүгд
                            </option>
                            {badgeChoices.map((badgeChoice) => (
                                <option key={badgeChoice._id} value={badgeChoice._id}>
                                    {badgeChoice.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Эхлэх огноо</Form.Label>
                        <Form.Control
                            type="date"
                            format="yyyy-mm-dd"
                            value={startDate}
                            onChange={(e) => {
                                setStartDate(e.target.value)
                            }}
                        />
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridPassword">
                        <Form.Label>Дуусах огноо</Form.Label>
                        <Form.Control
                            type="date"
                            format="yyyy-mm-dd"
                            placeholder={endDate || 'дуусах огноо'}
                            value={endDate}
                            onChange={(e) => {
                                setEndDate(e.target.value)
                            }}
                        />
                    </Form.Group>
                </Form.Row>
                <Button variant="primary" className="btn btn-sm" size="md" onClick={handleSearch}>
                    Хайх
                </Button>
            </Form>
        </>
    )
}

export default Filter
